var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenTick2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1555 8.32819C18.5358 10.1947 18.2647 12.1352 17.3875 13.8261C16.5103 15.5169 15.0799 16.8559 13.3349 17.6198C11.5899 18.3837 9.63579 18.5263 7.7984 18.0238C5.961 17.5212 4.35142 16.404 3.23806 14.8584C2.12469 13.3128 1.57486 11.4322 1.68024 9.53022C1.78562 7.62826 2.53985 5.81992 3.81715 4.40676C5.09445 2.99359 6.81761 2.06102 8.69927 1.76457C10.5809 1.46812 12.5074 1.8257 14.1573 2.77769",
    stroke: "#00A63E",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49512 9.16054L9.99347 11.6589L18.3213 3.33105",
    stroke: "#00A63E",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick2);
export default __webpack_public_path__ + "static/media/greenTick2.a5798ebd8557796178136472a6b82944.svg";
export { ForwardRef as ReactComponent };